module.exports = __webpack_public_path__ + "jtails-build/img/no-record.dade0a24.svg";